
import React, {
  useState,
  useEffect,
  useRef
} from "react";

import { createPortal } from "react-dom";
import { useAuth } from "../AuthContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfinity } from '@fortawesome/free-solid-svg-icons';

import "./HeartPopup.css";
import heart from "../imagesHome/heart.png";

const apiUrl = process.env.REACT_APP_API_URL;

const HeartPopup = ({ livesCount }) => {
  const auth = useAuth();

  // ==========================================
  // PREMIUM STATUS
  // ==========================================

  const [isPremium, setIsPremium] = useState(
    auth?.user?.is_premium === true
  );

  // ==========================================
  // POPUP STATES
  // ==========================================

  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [animateLoss, setAnimateLoss] = useState(false);

  const previousLivesCount = useRef(livesCount);

  const visibleLives = Math.min(
    3,
    Math.max(0, Number(livesCount) || 0)
  );

  // ==========================================
  // VERIFICARE PREMIUM DIN BACKEND
  // ==========================================

  useEffect(() => {
    let cancelled = false;

    const fetchPremiumStatus = async () => {
      try {
        const response = await fetch(`${apiUrl}/user`, {
          method: "GET",
          credentials: "include"
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();

        if (!cancelled) {
          setIsPremium(data?.is_premium === true);
        }
      } catch (error) {
        console.error(
          "Eroare la verificarea statusului Premium:",
          error
        );
      }
    };

    fetchPremiumStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  // ==========================================
  // SINCRONIZARE CU AUTHCONTEXT
  // ==========================================

  useEffect(() => {
    if (typeof auth?.user?.is_premium === "boolean") {
      setIsPremium(auth.user.is_premium);
    }
  }, [auth?.user?.is_premium]);

  // ==========================================
  // DESCHIDERE POPUP
  // ==========================================

  const openPopup = () => {
    if (isVisible && isOpen) return;

    setIsVisible(true);

    requestAnimationFrame(() => {
      setIsOpen(true);
    });
  };

  // ==========================================
  // INCHIDERE POPUP
  // ==========================================

  const closePopup = () => {
    if (!isVisible) return;

    setIsOpen(false);
  };

  // ==========================================
  // ANIMATIE PIERDERE VIATA
  // ==========================================

  useEffect(() => {
    if (
      !isPremium &&
      livesCount < previousLivesCount.current
    ) {
      setAnimateLoss(true);

      const timer = setTimeout(() => {
        setAnimateLoss(false);
      }, 500);

      previousLivesCount.current = livesCount;

      return () => clearTimeout(timer);
    }

    previousLivesCount.current = livesCount;
    setAnimateLoss(false);
  }, [livesCount, isPremium]);

  // ==========================================
  // ANIMATIE INCHIDERE POPUP
  // ==========================================

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  // ==========================================
  // BLOCARE SCROLL CAT TIMP POPUP-UL E DESCHIS
  // ==========================================

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    } else {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [isOpen]);

  // ==========================================
  // INCHIDERE CU ESCAPE
  // ==========================================

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [isVisible]);

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <div className="heart-popup-container">

      {/* INIMILE DIN BARA DE PROGRES */}

      <button
        type="button"
        className={`oriented-heart-track ${
          animateLoss && !isPremium
            ? "hearts-loss-animation"
            : ""
        }`}
        onClick={isOpen ? closePopup : openPopup}
        aria-label={
          isPremium
            ? "Vieti nelimitate Premium. Deschide detaliile."
            : `Ai ${visibleLives} vieti. Deschide detaliile vietilor.`
        }
      >

        <span
          className="header-hearts-list"
          aria-hidden="true"
        >

          {isPremium ? (

            /* PREMIUM: INIMA + INFINIT */

            <span className="heart-premium-unlimited">

             

             
<span className="heart-premium-infinity">
  <FontAwesomeIcon icon={faInfinity} />
</span>


            </span>

          ) : (

            /* GRATUIT: 3 INIMI */

            [0, 1, 2].map((index) => (
              <img
                key={`header-heart-${index}`}
                src={heart}
                className={`header-heart-icon ${
                  index < visibleLives
                    ? "header-heart-active"
                    : "header-heart-consumed"
                }`}
                draggable={false}
                alt=""
              />
            ))

          )}

        </span>

      </button>

      {/* ==========================================
          POPUP DETALII VIETI
      ========================================== */}

      {isVisible &&
        createPortal(
          <>

            <div
              className={`popup-question-overlay ${
                isOpen ? "open" : ""
              }`}
              onClick={closePopup}
            />

            <div
              className={`popup-question ${
                isOpen ? "open" : ""
              }`}
              role="dialog"
              aria-modal="true"
              aria-label="Detalii vieti"
            >

              {/* INCHIDE */}

              <button
                type="button"
                className="popup-question-close"
                onClick={closePopup}
                aria-label="Inchide"
              >
                x
              </button>

              <div className="popup-question-content">

                {/* ICON */}

                <div className="popup-question-coins-info heart-popup-coins-info">

                  <img
                    src={heart}
                    className="heart-popup-bigicon"
                    draggable={false}
                    alt="Vieti"
                  />

                  <span>Vieti</span>

                </div>

                {/* REZUMAT */}

                <div className="heart-popup-summary">

                  <div className="heart-popup-title-row">

                    <h3>
                      {isPremium
                        ? "Vieti nelimitate ∞"
                        : `Ai ${visibleLives} vieti`}
                    </h3>

                  </div>

                  {/* INIMI / INFINIT */}

                  <div
                    className="heart-popup-lives-row heart-popup-lives-row--summary"
                    aria-label={
                      isPremium
                        ? "Vieti nelimitate"
                        : `Ai ${visibleLives} vieti din 3`
                    }
                  >

                    {isPremium ? (

                  
<span className="heart-popup-infinity">
  <FontAwesomeIcon icon={faInfinity} />
</span>


                    ) : (

                      [0, 1, 2].map((index) => (
                        <img
                          key={index}
                          src={heart}
                          className={`heart-popup-info-icon ${
                            index < visibleLives
                              ? "heart-slot-filled"
                              : "heart-slot-empty"
                          }`}
                          draggable={false}
                          alt={
                            index < visibleLives
                              ? "Viata activa"
                              : "Viata pierduta"
                          }
                        />
                      ))

                    )}

                  </div>

                  {/* DESCRIERE */}

                  <p>
                    {isPremium
                      ? "Cu ContaLearn Premium ai vieti nelimitate si poti invata fara intreruperi."
                      : "Foloseste-le pentru a continua chiar si daca mai faci greseli."}
                  </p>

                  {/* BUTON */}

                  <button
                    type="button"
                    className="heart-popup-btn"
                    onClick={closePopup}
                  >
                    Am inteles
                  </button>

                </div>

              </div>

            </div>

          </>,
          document.body
        )}

    </div>
  );
};

export default HeartPopup;
